module.exports = __webpack_public_path__ + "static/media/lL29Pma.d87a9645.png";